// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__ex44e","title":"Images45_title__2dXrx","images":"Images45_images__VLM2q"};